<template>
  <div class="hello">
    <h1>Welcome to the new PAX Dashboard</h1>
    <div>
      <SchemaList/>
    </div>
  </div>
</template>

<script>
import SchemaList from './SchemaList.vue'

export default {
  name: 'Dashboard',
  components: {
    SchemaList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue